import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import MenuButton from "./Components/Common/Menu/MenuButton";
import Login from "./pages/common/Login";
import Dashboard from "./pages/common/Dashboard"; // Replace with your main dashboard page
import SignUp from "./pages/common/SignUp"; // Replace with your main dashboard page
import useAuthStore from "./store/useAuthStore";
import './App.css';
import WorkerLogin from "./Components/WorkerLogin/WorkerLogin";
import WorkerTableView from "./pages/pos/WorkerTablePage";
import OrderTable from "./pages/common/OrderTable";

const PrivateRoute = ({ element }) => {
    const { user } = useAuthStore();
    return user ? element : <Navigate to="/login" />;
};

function App() {
    return (
        <Router>
            <MenuButton transparent={true} /> {/* This will be on all routes */}
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/SignUp" element={<SignUp />} />
                <Route path="/workerlogin" element={<WorkerLogin />} />
                <Route path="/worker-table-view" element={<WorkerTableView />} />
                <Route path="/order-dashboard" element={<OrderTable />} />
                <Route path="/dashboard" element={<PrivateRoute element={<Dashboard />} />} />
                <Route path="*" element={<Navigate to="/dashboard" />} />
            </Routes>
        </Router>
    );
}

export default App;
